import {getModuleContent} from "@/scripts/common/utilities/generalSection.js";
import {CtaTypesEnum} from "@/scripts/common/enums.js";

function isLightFontWeight(fontWeight) {
    if (fontWeight === null || fontWeight === undefined) return false;

    const numericWeight = Number(fontWeight);
    if (!Number.isNaN(numericWeight)) {
        return numericWeight <= 300;
    }

    const normalizedWeight = `${fontWeight}`.toLowerCase();
    return normalizedWeight.includes("light") || normalizedWeight.includes("thin");
}

export default {
    props: {moduleId: String},
    computed: {
        ctaData() {
            return (this.moduleId ? getModuleContent(this.section, this.moduleId) : this.section)?.cta;
        },
        ctaType() {
            return this.ctaData?.type ?? CtaTypesEnum.PRIMARY;
        },
        ctaActionType() {
            return this.ctaData?.actionType || "open-link";
        },
        ctaActionValue() {
            return this.ctaData?.url || "";
        },
        showActionIcon() {
            if (this.ctaActionType === "copy-email") return true;
            return !!this.ctaData?.showIcon;
        },
        useLightCtaIcon() {
            const fontStyleKey = this.ctaType === CtaTypesEnum.SECONDARY ? "secondaryButton" : "button";
            const fontWeight = this.$store.getters["design/fontStyles"]?.[fontStyleKey]?.fontWeight;

            return isLightFontWeight(fontWeight);
        },
    },
    methods: {
        getCtaActionIconName({isCopied = false} = {}) {
            const lightSuffix = this.useLightCtaIcon ? "-light" : "";

            if (this.ctaActionType === "copy-email") {
                return isCopied ? "check" : `cta-copy-email${lightSuffix}`;
            }
            if (this.ctaActionType === "navigate-to-page") {
                return `cta-open-page${lightSuffix}`;
            }
            return `cta-open-link${lightSuffix}`;
        },
    },
};
